<template>
  <div class="admin desktop">
    <h1 class="mb-6">Settings</h1>

    <UsersCard class="mb-4" />

    <!-- Tokens -->
    <v-card
      v-if="workspace"
      flat
      class="shadcn-card mb-4"
      style="max-width: 800px"
    >
      <div class="shadcn-card-header">Tokens</div>
      <div class="shadcn-card-content">
        <div class="d-flex justify-space-between">
          <div>
            <p
              style="
                margin-bottom: 0;
                font-size: 18pt;
                font-weight: 700;
                color: #09090b;
              "
            >
              {{ workspace.counter.tokens.toLocaleString() }}
            </p>
            <p class="shadcn-muted" style="margin-bottom: 0">
              Stix AI tokens left
            </p>
          </div>
          <div class="d-flex flex-column justify-end align-end">
            <p class="shadcn-muted text-right" style="margin-bottom: 0">
              Renewal of<br />
              2.000.000 tokens<br />
              in
              <span style="font-weight: 600; color: #09090b">{{
                daysLeft
              }}</span>
              days.
            </p>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Workspace -->
    <v-card v-if="workspace" flat class="shadcn-card" style="max-width: 800px">
      <div class="shadcn-card-header">Workspace</div>
      <div class="shadcn-card-content">
        <div>
          <label class="shadcn-label">Workspace name</label>
          <v-text-field
            hide-details
            v-model="workspace_name"
            variant="outlined"
            density="compact"
            class="shadcn-input"
          ></v-text-field>
        </div>

        <div class="mt-5">
          <label class="shadcn-label">Country & Timezone</label>
          <v-autocomplete
            :menu-props="{ offsetY: true }"
            placeholder="Country"
            v-model="country"
            :items="sorted_countries"
            item-title="name"
            return-object
            variant="outlined"
            density="compact"
            class="shadcn-input"
            hide-details
            @change="checkTZ"
          ></v-autocomplete>
          <v-autocomplete
            v-if="workspace.country && workspace.country.zones.length > 0"
            class="shadcn-input mt-2"
            :menu-props="{ offsetY: true }"
            placeholder="Timezone"
            v-model="timezone"
            :items="workspace.country.zones"
            item-title="name"
            variant="outlined"
            density="compact"
            hide-details
          ></v-autocomplete>
          <p class="shadcn-muted mt-3" style="max-width: 80%">
            When setting a time on a schedule or when you schedule a post, it
            will be sent out according to this timezone.
          </p>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import UsersCard from "@/components/users/UsersCard.vue";
import { timezones } from "@/mixins/timezones";
import { mapState } from "vuex";
import { DateTime } from "luxon";

export default {
  components: {
    UsersCard,
  },
  mixins: [timezones],
  computed: {
    ...mapState({
      workspace: (state) => state.workspace.workspace,
    }),
    sorted_countries() {
      let list = this.countries;
      list.sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0));
      return list;
    },
    country: {
      get() {
        return this.workspace.country;
      },
      set(value) {
        this.$store.dispatch("updateWorkspace", {
          type: "country",
          value: value,
        });
      },
    },
    timezone: {
      get() {
        return this.workspace.timezone;
      },
      set(value) {
        this.$store.dispatch("updateWorkspace", {
          type: "timezone",
          value: value,
        });
        // To DO: if timezone changes, then it should change the Timezone of all posts that are active and/scheduled in the future.
      },
    },
    workspace_name: {
      get() {
        return this.workspace.about.name;
      },
      set(value) {
        this.$store.dispatch("updateWorkspace", {
          type: "about.name",
          value: value,
        });
      },
    },
    daysLeft() {
      const today = DateTime.now();
      const next = DateTime.fromObject({
        day: 1,
        month: today.month < 12 ? today.month + 1 : 1,
        year: today.month < 12 ? today.year : today.year + 1,
      });
      const diff = next.diffNow("days");
      return Math.ceil(diff.values.days);
    },
  },
  methods: {
    checkTZ(v) {
      if (v.zones.length > 0) {
        this.timezone = v.zones[0];
      }
    },
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.desktop {
  padding: 20px 44px 0 44px;
  max-width: 1900px;
}
</style>
